import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Grid,
  Typography,
  Icon,
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import styles from './styles';

export class KpiCardsComponent extends React.Component {
  render() {
    const {
      classes,
      analytics,
      loading,
    } = this.props;

    return (
      <Grid container spacing={4}>
        <Grid item xs md={4} className={classes.gridItem}>
          <Card>
            <CardHeader
              subheader={<Typography variant="h5" className={classes.greyColor}>Created</Typography>}
              title={
                loading
                  ? <CircularProgress />
                  : <Typography variant="h1" color="textPrimary">{analytics.createdEvents}</Typography>
              }
            />
            <CardContent>
              <Typography variant="caption" className={classes.greyColor}>
                <Icon fontSize="small" className={classes.footerIcon}>{analytics.createdEventsTrendingIcon}</Icon>
                {analytics.createdEventsTrendingComment}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs md={4} className={classes.gridItem}>
          <Card>
            <CardHeader
              subheader={<Typography variant="h5" className={classes.greyColor}>Completed</Typography>}
              title={
                loading
                  ? <CircularProgress />
                  : <Typography variant="h1" color="textPrimary">{analytics.completedEvents}</Typography>
              }
            />
            <CardContent>
              <Typography variant="caption" className={classes.greyColor}>
                <Icon fontSize="small" className={classes.footerIcon}>{analytics.completedEventsTrendingIcon}</Icon>
                {analytics.completedEventsTrendingComment}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs md={4} className={classes.gridItem}>
          <Card>
            <CardHeader
              subheader={<Typography variant="h5" className={classes.greyColor}>Average Active Time</Typography>}
              title={
                loading
                  ? <CircularProgress />
                  : <Typography variant="h1" color="textPrimary">{analytics.averageActiveTime}</Typography>
              }
            />
            <CardContent>
              <Typography variant="caption" className={classes.greyColor}>
                <Icon fontSize="small" className={classes.footerIcon}>{analytics.averageActiveTimeTrendingIcon}</Icon>
                {analytics.averageActiveTimeTrendingComment}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
}

KpiCardsComponent.propTypes = {
  classes: PropTypes.object,
  analytics: PropTypes.object,
  loading: PropTypes.bool,
};

KpiCardsComponent.defaultProps = {
  classes: {},
  analytics: {},
  loading: false,
};

export default (withStyles(styles, { withTheme: true })(KpiCardsComponent));
